import React, { useState, useEffect, useMemo, useRef, useCallback } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Cookies from 'js-cookie';
import { useParams } from "react-router-dom";
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import Checkbox from '@material-ui/core/Checkbox';
import Collapse from '@material-ui/core/Collapse';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import moment from 'moment';
import { useHistory } from "react-router-dom";
import { useDropzone } from 'react-dropzone';
import SwapHorizIcon from '@material-ui/icons/SwapHoriz';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

import Autocomplete from '@material-ui/lab/Autocomplete';
import { FormControl, } from '@mui/material';
import {
    MaterialReactTable,

} from 'material-react-table';
import { Card, CardContent } from '@mui/material';

import CancelIcon from '@mui/icons-material/Cancel';
import EditIcon from '@mui/icons-material/Edit';


import DeleteIcon from '@mui/icons-material/Delete';


import { format, isValid, parse } from 'date-fns';

import AppBar from '@mui/material/AppBar';
import {
    Box,
    Tooltip
} from '@mui/material';
 import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import InputAdornment from "@mui/material/InputAdornment";
import SwipeableViews from 'react-swipeable-views';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Skeleton from '@material-ui/lab/Skeleton';
import IconButton from '@material-ui/core/IconButton';
import AddIcon from '@mui/icons-material/Add';
import SaveIcon from '@mui/icons-material/Save';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';

import api from '../../../../../../services/api';
import NavegadorGestao from "../../../../../../components/NavBarGestao";

import { Stack } from '@mui/material';

import { Button, MenuItem, Select, InputLabel } from "@material-ui/core";
import Pagination from '@material-ui/lab/Pagination';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import { styled } from '@material-ui/styles';

import miniatura_pdf from '../../../../../../assets/imgs/miniatura_pdf.png';
import office from '../../../../../../assets/imgs/office.png';
import comprovante from '../../../../../../assets/imgs/comprovante.png';
import RequestQuoteIcon from '@mui/icons-material/Calculate';

import {
    DataGrid,  
    GridToolbarContainer,
    GridToolbarColumnsButton,
    GridToolbarFilterButton,
    GridToolbarExport,
    GridToolbarDensitySelector,
} from '@mui/x-data-grid';

const drawerWidth = 240;




const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        '& .cabecalho_transparente': {
            backgroundColor: 'rgba(0, 0, 0, 0)',
            color: 'rgba(0, 0, 0, 0)',
        },
        '& .cabecalho_azul': {
            backgroundColor: 'rgba(0, 0, 255, 1)',
            color: 'white',
        },
        '& .cabecalho_verde': {
            backgroundColor: 'rgba(0, 100, 0, 1)',
            color: 'white',
        },
        '& .cabecalho_verde_claro': {
            backgroundColor: 'rgba(107,142,35, 1)',
            color: 'white',
        },
        '& .cabecalho_marrom_claro': {
            backgroundColor: 'rgba(184,134,11, 1)',
            color: 'white',
        },
        '& .cabecalho_verde_cyan': {
            backgroundColor: 'rgba(0,139,139, 1)',
            color: 'white',
        },
        '& .cabecalho_verde_dark_sea': {
            backgroundColor: 'rgba(60,179,113, 1)',
            color: 'white',
        },
        '& .cabecalho_marrom_escuro': {
            backgroundColor: 'rgba(139,69,19, 1)',
            color: 'white',
        },
        '& .cabecalho_marrom_chocolate': {
            backgroundColor: 'rgba(210,105,30, 1)',
            color: 'white',
        },
        '& .cabecalho_darkslate': {
            backgroundColor: 'rgba(47,79,79, 1)',
            color: 'white',
        },
        '& .super-app.negative': {
            backgroundColor: 'rgba(157, 255, 118, 0.49)',
            color: '#1a3e72',
            fontWeight: '600',
        },
        '& .super-app.positive': {
            backgroundColor: '#d47483',
            color: '#1a3e72',
            fontWeight: '600',
        },
        '& .super-app.neutro': {
            backgroundColor: '#363636',
            color: 'white',
            fontWeight: '600',
        },
    },
    toolbar: {
        paddingRight: 24, // keep right padding when drawer closed
    },
    toolbarIcon: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: '0 8px',
        ...theme.mixins.toolbar,
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    appBarShift: {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    menuButton: {
        marginRight: 36,
    },
    menuButtonHidden: {
        display: 'none',
    },
    title: {
        flexGrow: 1,
    },
    drawerPaper: {
        position: 'relative',
        whiteSpace: 'nowrap',
        width: drawerWidth,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    drawerPaperClose: {
        overflowX: 'hidden',
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        width: theme.spacing(7),
        [theme.breakpoints.up('sm')]: {
            width: theme.spacing(9),
        },
    },
    appBarSpacer: theme.mixins.toolbar,
    content: {
        flexGrow: 1,
        height: '100vh',
        overflow: 'auto',
    },
    container: {
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4),
    },
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
    },
    fixedHeight: {
        height: 240,
    },
    table: {
        minWidth: 650,
    },
}));

const dropzoneStyles = {
    border: '4px dashed #000000',
    borderRadius: '4px',
    padding: '2px',
    textAlign: 'center',
    cursor: 'pointer',
    margin: '2px 0',
};




export default function CadastrarNF({ lancamento, closeCadastrarNF, }) {

       function formatDateToISO(date) {
            if (!date) return null;
    
            // Se já estiver no formato ISO (yyyy-MM-dd), apenas retorna
            if (/^\d{4}-\d{2}-\d{2}$/.test(date)) {
                return date;
            }
    
            // Se vier no formato dd/MM/yyyy
            const [dia, mes, ano] = date.split("/");
            return `${ano}-${mes}-${dia}`;
        }
    
    
    
        const [numero, setNumero] = useState('');
            const [chaveAcesso, setChaveAcesso] = useState('');
            const [dataNF, setDataNF] = useState(moment().format('DD/MM/YYYY'));
        const [valorTotal, setValorTotal] = useState(0.0);



    async function handleSaveNF() {
        try {

            var id_user = Cookies.get('id_usuario');

 

            const parsedDate = parse(dataNF, 'dd/MM/yyyy', new Date());
            if (isValid(parsedDate)) {

            } else {
                alert("A data é invalida!");
                return;
            }

            

            const dataFormatada = format(parse(dataNF, 'dd/MM/yyyy', new Date()), 'yyyy-MM-dd');


 


            const cadastro = {

                id_lancamento: lancamento.id_lancamento,
                usuario: { id_usuario: id_user, },
                 data_nf: dataFormatada,
                 numero: numero,
                 chave_acesso: chaveAcesso,
                 valor_total: valorTotal,

                

            };


          

            const headers = {
                'Authorization': 'Bearer ' + Cookies.get("token")
            }

            const response = await api.post('/v1/protected/financeiro/lancamentos/notasfiscais/cadastrar', cadastro,
                { headers: headers });

            const cadastro_salvo = response.data;
            if (cadastro_salvo) {
                alert("Nota Fiscal Cadastrada!");
                closeCadastrarNF();


            } else {
                alert("Erro de Conexão, tente novamente mais tarde");
            }
        } catch (_err) {
            console.log("erro ao cadastrar: " + _err);
            alert("Erro de Conexão, tente novamente!");
        }

    };


    


    const [loading, setLoading] = useState(false);

   



    return (
        <div>
            {!loading && (
                <Grid
                    item xs={12}
                    alignItems="center"
                    justifyContent="center"
                    container
                    style={{ marginTop: 5 }}
                    spacing={2}
                >
                    <Grid
                        item
                        xs={12}
                        container
                        alignItems="center"
                        justifyContent="center"
                        style={{ padding: 5 }}
                          spacing={2}
                    >

 <Grid item xs={6}>
                                <TextField
                                    variant="standard"
                                    name="numero"
                                    label="Número"
                                    id="numero"
                                    value={numero}
                                    onChange={(e) => setNumero(e.target.value)}
                                    fullWidth
                                    multiline
                                    minRows={1}
                                />
                            </Grid>

                             <Grid item xs={6}>
                                <TextField
                                    variant="standard"
                                    name="chaveAcesso"
                                    label="Chave Acesso"
                                    id="chaveAcesso"
                                    value={chaveAcesso}
                                    onChange={(e) => setChaveAcesso(e.target.value)}
                                    fullWidth
                                    multiline
                                    minRows={1}
                                />
                            </Grid>
                        
                            <Grid
                                                     item
                                                     xs={4}
                                                     container
                                                     alignItems="center"
                                                     justifyContent="center"
                                                     style={{ padding: 5 }}
                                                 >
                                                     <TextField
  id="valor"
  variant="standard"
  value={valorTotal}
  onChange={(e) => {
    // Permite apenas números e ponto
    const newValue = e.target.value
  .replace(/[^0-9.]/g, '')        // remove caracteres inválidos
  .replace(/\.(?=.*\.)/, '');     // remove pontos extras
setValorTotal(newValue);
    setValorTotal(newValue);
  }}
  label="Valor"
  fullWidth
/>
                                                 </Grid>
                         
                                                 <Grid
                                                     item
                                                     xs={2}
                                                     container
                                                     alignItems="center"
                                                     justifyContent="center"
                                                     style={{ padding: 5 }}
                                                 >
                                                     <TextField
                                                         id="dataNF"
                                                         variant="standard"
                                                         value={dataNF}
                                                         onChange={(e) => setDataNF( e.target.value )}
                                                         label="Data da NF"
                                                         fullWidth
                         
                                                     />
                                                 </Grid>
                      
 

                    </Grid>
                    <Grid
                        item
                        xs={12}
                        container
                        alignItems="center"
                        justifyContent="center"
                        spacing={2}
                        style={{ marginTop: 5 }}
                    >
                        <IconButton color="success" onClick={   () => handleSaveNF()  } >
                            <SaveIcon />
                        </IconButton>
                        <IconButton color="error" onClick={() => closeCadastrarNF()} >
                            <CancelIcon />
                        </IconButton>
                    </Grid>
                </Grid>

            )
            }




        </div>
    );
}



